class DetailsModal extends HTMLElement {
  constructor() {
    super();
    this.detailsContainer = this.querySelector('details');
    this.summaryToggle = this.querySelector('summary');

    this.detailsContainer.addEventListener('keyup', (event) => event.code.toUpperCase() === 'ESCAPE' && this.close());
    this.summaryToggle.addEventListener('click', this.onSummaryClick.bind(this));
    
    const closeButton = this.querySelector('button[type="button"].modal__close-button') || this.querySelector('button[type="button"]');
    if (closeButton) {
      closeButton.addEventListener('click', this.close.bind(this));
    }

    this.summaryToggle.setAttribute('role', 'button');
  }

  isOpen() {
    return this.detailsContainer.hasAttribute('open');
  }

  onSummaryClick(event) {
    event.preventDefault();
    event.stopPropagation();
    if (this.detailsContainer.hasAttribute('open')) {
      this.close();
      return;
    }
    this.open(event);
  }

  onBodyClick(event) {
    if (this.ignoreBodyClick) return;
    if (this.contains(event.target) && !event.target.classList.contains('modal-overlay')) return;
    this.close(false);
  }

  open(event) {
    document.querySelector('sticky-header')?.onHeaderOverlayOpening?.();
    this.ignoreBodyClick = true;
    this.onBodyClickEvent = this.onBodyClickEvent || this.onBodyClick.bind(this);
    this.detailsContainer.setAttribute('open', true);
    document.body.classList.add('overflow-hidden');
    document.querySelector('sticky-header')?.setHeaderHeight?.();

    trapFocus(
      this.detailsContainer.querySelector('[tabindex="-1"]'),
      this.detailsContainer.querySelector('input:not([type="hidden"])')
    );

    setTimeout(() => {
      this.ignoreBodyClick = false;
      document.body.addEventListener('click', this.onBodyClickEvent);
    });
  }

  close(focusToggle = true) {
    this.ignoreBodyClick = false;
    removeTrapFocus(focusToggle ? this.summaryToggle : null);
    this.detailsContainer.removeAttribute('open');
    document.body.removeEventListener('click', this.onBodyClickEvent);
    document.body.classList.remove('overflow-hidden');
    document.querySelector('sticky-header')?.restoreHeaderAfterOverlay?.();
  }
}

customElements.define('details-modal', DetailsModal);
